export { default } from './ElsnostresJocs';
